export const payload = {
  receiveMutation: 'RECEIVE_ACCOUNTS',
  receivingMutation: 'RECEIVING_ACCOUNTS',
  receiveMetadataMutation: 'RECEIVE_ACCOUNT_METADATA',
  receiveFailureMutation: 'RECEIVE_ACCOUNT_FAILURE',
  savingMutation: 'SAVING_ACCOUNT',
  saveFailureMutation: 'SAVING_ACCOUNT_FAILURE',
  incrementMutation: 'INCREMENT_ACCOUNT_COUNT',
  updatingMutation: 'UPDATING_ACCOUNT',
  updateFailureMutation: 'UPDATING_ACCOUNT_FAILURE',
  deleteMutation: 'DELETE_ACCOUNT',
  deletingMutation: 'DELETING_ACCOUNT',
  deleteFailureMutation: 'DELETING_ACCOUNT_FAILURE',
  resetMetaMutation: 'RESET_ACCOUNT_META',
  clearMutation: 'CLEAR_ACCOUNT_STATE',
  moduleName: 'account',
  endpoint: 'accounts',
  searchableFields: ['type', 'name', 'description', 'code']
}
